import React from 'react';
import Link from 'next/link';

const checkUrlPlatformType = (value: string) => {
  let urlValue: string = '';

  if (!value.includes('.searates.')) {
    urlValue = `/${value}`;
  } else {
    urlValue = `${value}`;
  }

  return urlValue;
};

export const parseTextWithLinksAndBold = (text:string): React.ReactNode[] => {
  const parts = [];
  const regex = /\[\[link:(.*?)\]\](.*?)\[\[\/link\]\]|\[\[bold\]\](.*?)\[\[\/bold\]\]/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const [fullMatch, link, linkText, boldText] = match;

    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    if (link && linkText) {
      parts.push(
      <Link className="freight-dictionary-landing__link" href={checkUrlPlatformType(link)} key={match.index} target="_blank" rel="noopener noreferrer" >
        {linkText}
      </Link>
    );
    } else if (boldText) {
      parts.push(
        <strong className="freight-dictionary-landing__description-paragraph--bold" key={match.index}>
        {boldText}
        </strong>
    );
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  return parts;
};